import React from 'react';
import { range } from 'lodash';
import { ModelRule4, Rule4State } from './Rule4State';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { EventId, MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import { DateTimeInput } from 'src/components/DateTimeInput/DateTimeInput';

interface Rule4PropsType {
    model: ModelRule4;
}

const Rule4 = observer((props: Rule4PropsType): React.ReactElement => {
    const { model } = props;

    const disabledClass = model.isChange ? '' : 'disabled';

    return (
        <tr>
            <td />
            <td className='element'>
                <DateTimeInput
                    value={model.valueEndTime}
                    onChange={(endTime: string | null): void => model.setEndTime(endTime)}
                    dateFormat='yyyy-MM-dd'
                    timeFormat='HH:mm:ss'
                />
            </td>
            <td className='element'>
                <select
                    value={model.valueWinner}
                    onChange={(e): void => model.setSelection(e.target.value)}
                >
                    <option />
                    {model.selections.map((s) => (
                        <option
                            key={s.id}
                            value={s.id}
                        >
                            {s.name}
                        </option>
                    ))}
                </select>
            </td>
            <td className='element'>
                <select
                    value={model.valueDeduction}
                    onChange={(e): void => model.setDeduction(e.target.value)}
                >
                    <option value='0'>No</option>
                    {range(5, 100, 5).map((x) => (
                        <option
                            key={x}
                            value={x}
                        >
                            {x}p
                        </option>
                    ))}
                </select>
            </td>
            <td>
                <a
                    href='#'
                    className={`btn ${disabledClass}`}
                    onClick={(e): void => {
                        e.preventDefault();
                        model.saveOrAdd().catch((error: unknown) => {
                            console.error(error);
                        });
                    }}
                >
                    {model.buttonLabel}
                </a>
            </td>
        </tr>
    );
});

interface PropsType {
    eventId: EventId;
    marketId: MarketId;
}

//     onRule4UpdateRequest: PropTypes.func.isRequired,
//     onRule4CreateRequest: PropTypes.func.isRequired

export const Rule4Settings = observer((props: PropsType): React.ReactElement => {
    const appState = useAppStateContext();
    const [rule4State] = React.useState(() => new Rule4State(appState, props.eventId, props.marketId));

    return (
        <div className='rule-4-settings'>
            <table className='form'>
                <thead>
                    <tr>
                        <th>
                            <strong>Rule 4</strong>
                        </th>
                        <th>Bets before</th>
                        <th>Runner</th>
                        <th>Deduction (p)</th>
                        <th>
                            <a
                                href='#'
                                className='btn btn-add'
                                onClick={rule4State.add}
                            >
                                Add new
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {rule4State.listForView().map((model) => (
                        <Rule4
                            key={model.id}
                            model={model}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
});
